import React from 'react';
import PendingPreAssessments from './PendingPreAssessments';

export default function DownloadedImpactReport() {
  return <PendingPreAssessments title="Impact Report Downloaded" type="download" impactReport impactDownloadedView />;
}
